<template>
  <h1>This is my not found page</h1>
</template>

<script>
export default {}
</script>

<style></style>
